import React from 'react';
import { useParams } from 'react-router';
import { PeopleCMSLayout } from '../people.cms.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function TeamPeopleCMSPage(): JSX.Element {
  const params = useParams();

  return <PeopleCMSLayout path={PagePath.userManagementTeamPeople} slugs={{ companySlug: params.companySlug!, teamSlug: params.teamSlug! }} type="team" />;
}